<template lang="pug">
  div
    t-key-value-data(
      v-for="(row, idx) in rows"
      :key="idx"
      :item="row"
    )
    div(v-if="currentTaxBill && currentTaxBill.items")
      h3(class="title-20px my-4") {{ $t('Nomenclature of Tax Bill') }}
      div(
        v-for="item in currentTaxBill.items"
        :key="item.id"
      )
        t-key-value-data(
          v-for="(row, idx) in createItemRows(item)"
          :key="idx"
          :item="row"
        )
</template>

<script>
import { mapGetters } from 'vuex'
import MTable from '~/components/modules/tables/m-table'
import TKeyValueData from '~/components/templates/t-key-value-data'

export default {
  name: 'MTaxbillDetails',
  components: {
    TKeyValueData,
    MTable
  },
  props: {
    taxBill: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters('taxbills', {
      taxBills: 'items'
    }),
    currentTaxBill() {
      return this._.find(this.taxBills, item => item.id === this.taxBill.id)
    },
    rows() {
      return [
        {
          key: this.$t('Organization'),
          value: this._.get(this.currentTaxBill, 'organization.name')
        },
        {
          key: this.$t('EDRPOU'),
          value: this._.get(this.currentTaxBill, 'organization.edrpou')
        },
        {
          key: this.$t('Date of compilation'),
          value: this.$moment.parseZone(this.currentTaxBill.date).format('DD.MM.YYYY')
        },
        {
          key: this.$t('Number of Tax Bill'),
          value: this._.get(this.currentTaxBill, 'number')
        },
        {
          key: this.$t('Date of registration tax bill in tax'),
          value: this.currentTaxBill.dateSent
            ? this.$moment.parseZone(this.currentTaxBill.dateSent).format('DD.MM.YYYY')
            : null
        },
        {
          key: this.$t('Name of buyer'),
          value: this._.get(this.currentTaxBill, 'hnamebuy')
        },
        {
          key: this.$t("Registration number of the taxpayer's registration card"),
          value: this._.get(this.currentTaxBill, 'hkbos')
        },
        {
          key: this.$t('buyer IPN'),
          value: this._.get(this.currentTaxBill, 'hkbuy')
        },
        {
          key: this.$t('Sum of tax bill'),
          value: this._.get(this.currentTaxBill, 'r04g11')
        },
        {
          key: this.$t('Sum of PDV'),
          value: this._.get(this.currentTaxBill, 'r03g11')
        },
        {
          key: this.$t('Status'),
          value: this.taxBillStatusesMap[this._.get(this.currentTaxBill, 'status')]
        }
      ]
    },
    taxBillStatusesMap() {
      return {
        new: 'Новий',
        send: 'Надісланий',
        ready: 'Готовий',
        error: 'Помилка',
        completed: 'Завершений'
      }
    },
    headers() {
      return [
        {
          text: 'Organization',
          value: 'organization.name',
          sortable: false,
          filterable: false
        },
        {
          text: 'EDRPOU',
          value: 'organization.edrpou',
          sortable: false,
          filterable: false
        },
        {
          text: 'Receiver name',
          value: 'hnamebuy',
          sortable: false,
          filterable: false
        },
        {
          text: 'Number',
          value: 'number',
          sortable: false,
          filterable: false
        },
        {
          text: 'Date',
          valueFormatter: taxBill => this.$moment.parseZone(taxBill.date).format('DD.MM.YYYY'),
          sortable: false,
          filterable: false
        }
      ]
    }
  },
  created() {
    this.fetchTaxBill()
  },
  methods: {
    async fetchTaxBill() {
      try {
        await this.$store.dispatch('taxbills/read', { id: this.taxBill.id })
      } catch (e) {
        this.$handlers.error(e, this)
      }
    },
    createItemRows(item) {
      return [
        {
          key: this.$t('Name'),
          value: item.rxxxxg3s
        },
        {
          key: this.$t('Quantity (volume, amount)'),
          value: item.rxxxxg5
        },
        {
          key: this.$t('Unit supply price'),
          value: item.rxxxxg6
        },
        {
          key: this.$t('Delivery volumes excluding VAT'),
          value: item.rxxxxg010
        },
        {
          key: this.$t('VAT sum'),
          value: item.rxxxxg11_10
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss"></style>
